export { TestimonialMultipleColumn } from './TestimonialMultipleColumn';
export type { Props as TestimonialMultipleColumnProps } from './TestimonialMultipleColumn';
